import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function ImprimareMetalPage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Tehnologii imprimare 3D"
      backTo={url.dept("tehnologii-imprimare-3d")}
      number="03"
      eyebrow="Tehnologie BMD · Desktop Metal"
      title={["Imprimare 3D", "din metal."]}
      tagline="Performanță · Durabilitate · Flexibilitate — Bound Metal Deposition urmată de sinterizare, cu densități până la 98%."
      intro={[
        "Spre deosebire de sistemele bazate pe laser, care topesc selectiv pulberea de metal, imprimăm 3D prin extrudarea metalului legat în tije de polimer — similar cu FDM. Această tehnologie nu necesită cerințele stricte de securitate asociate imprimării 3D a metalelor și permite caracteristici noi, cum ar fi umplutura cu celule închise pentru rezistență îmbunătățită.",
        "Cuptorul de sinterizare este conceput să fie simplu de folosit: încălzește piesele pentru a elimina lianții, apoi crește temperatura până aproape de punctul de topire pentru sinterizare de calitate industrială. Profilele de temperatură integrate — adaptate fiecărui tip de construcție și material — asigură încălzire și răcire uniformă, fără tensiuni reziduale.",
      ]}
      bullets={[
        "Piese cu densități până la 98% (comparabile cu turnate).",
        "Pereți de la 4 mm până la complet dense (5.25 mm).",
        "Cap standard 400μm sau înalta rezoluție 250μm.",
        "Sinterizare în vid până la 1400°C.",
      ]}
      programs={[
        "Aerospațial", "Automotive", "Inginerie mecanică",
        "Medicină", "Industrie petrolieră", "Maritim",
      ]}
      servicesEyebrow="Materiale metalice"
      servicesTitle="8 aliaje pentru aplicații industriale."
      services={[
        {
          title: "Oțel inoxidabil 316L",
          tags: "Rezistență la coroziune · medicină · aplicații maritime.",
          desc: "Aliaj remarcabil prin rezistența la coroziune și capacitatea de a face față mediilor solicitante. Ideal pentru industria medicală (durabilitate + rezistență la coroziune) și aplicații maritime (apă sărată, medii umede).",
        },
        {
          title: "Oțel 4140",
          tags: "Rezistență ridicată · aerospațial · mecanic.",
          desc: "Material esențial în inginerie mecanică și industria aerospațială. Rezistență excepțională, capacitatea de a face față stresului intens, combinație excelentă rezistență/greutate — pentru structuri ușoare și robuste.",
        },
        {
          title: "Oțel A2",
          tags: "Inoxidabil martensitic · duritate mare · uzură intensă.",
          desc: "Oțel inoxidabil martensitic apreciat pentru rezistența și duritatea sa. Componente durabile și rezistente în medii exigente — folosit pe scară largă în industrie.",
        },
        {
          title: "Cupru",
          tags: "Ductil și maleabil · conductivitate electrică remarcabilă.",
          desc: "Metal extrem de ductil și maleabil, esențial în industria electrică. Modelare ușoară + flux eficient al electricității — pentru aplicații în care conducerea și flexibilitatea sunt cruciale.",
        },
        {
          title: "Oțel D2",
          tags: "Rezistență la uzură · componente pentru medii solicitante.",
          desc: "Oțel inoxidabil martensitic pentru componente durabile care rezistă la uzură și stresuri intense — mediile industriale cu cerințe ridicate.",
        },
        {
          title: "H13",
          tags: "Oțel carbon · temperaturi înalte · prelucrare metale.",
          desc: "Oțel carbon cunoscut pentru rezistența la temperaturi înalte — utilizat în aplicații de prelucrare a metalelor pentru unelte și componente care necesită performanțe fiabile la temperaturi extreme.",
        },
        {
          title: "Aliaj Nichel IN625",
          tags: "Rezistență la coroziune · maritim · industrial.",
          desc: "Recunoscut pentru rezistența la coroziune — ideal pentru aplicații maritime și industriale unde protecția împotriva agresiunii mediilor marine este esențială.",
        },
        {
          title: "Titan Ti64",
          tags: "Rezistență ridicată + densitate scăzută · aerospațial · medical.",
          desc: "Aliaj de titan cu rezistență ridicată și greutate redusă. Extensiv utilizat în aeronave, rachete, sateliți, implanturi și dispozitive medicale — performanță și fiabilitate în cele mai solicitante medii.",
        },
      ]}
      stepsEyebrow="Cum funcționează"
      stepsTitle="Trei etape până la piesa metalică."
      steps={[
        {
          title: "Pregătire",
          desc: "Software sigur, bazat pe web, construiește planuri de imprimare din fișiere STL sau CAD — generează automat suporturi și parametrii de control pe baza geometriei și materialului.",
        },
        {
          title: "Imprimare (BMD)",
          desc: "Strat cu strat, „piesa verde\" este modelată prin extrudarea de tije metalice legate — pulbere metalică ținută la un loc de lianți polimerici. Depunerea Metalului Legat.",
        },
        {
          title: "Sinterizare",
          desc: "Piesele sunt puse în cuptor: liantul este îndepărtat pe măsură ce piesa este încălzită, iar particulele metalice se unesc. Rezultat: densitate până la 98%.",
        },
      ]}
      criteriaEyebrow="Setări personalizabile"
      criteriaTitle="Piese optimizate pentru viteză sau precizie."
      criteria={[
        "Pereți subțiri până la 4 mm sau piese complet dense până la 5,25 mm.",
        "Grosime înveliș ajustabilă — piese mai puternice sau prelucrare mai rapidă.",
        "Cap de imprimare standard 400μm pentru viteză de construcție.",
        "Cap de imprimare 250μm pentru caracteristici fine.",
        "Cameră de construcție încălzită → finisaj excelent al suprafeței.",
        "Structură interioară giroid → greutate redusă cu rezistență mare.",
        "Materiale certificate MPIF pentru densitate 98%.",
        "Sinterizare în vid la temperaturi până la 1400°C.",
      ]}
    />
  );
}
